import React from 'react';
import { LeftIcon } from "../utils"
import Button from '@directv-digital/fusion.atoms.button';

const BackButton = (
  { label, onClickFn, sx }:
  { label: string, onClickFn?: () => void; sx?: any}
) => (
  <Button
    buttontype='tertiary' mode='light'
    size='medium'
    icon={<LeftIcon />}
    left-icon={<LeftIcon />}
    onClick={onClickFn}
    sx={{
      margin: 0,
      ...sx
    }}
  >{label}
  </Button>
);

export default BackButton;
